import * as angular from 'angular';

import { baseModel } from './base.factory';

export const base = angular.module('go.models.baseModel', [])
	.factory('BaseModel', baseModel)
	.name;
